import intro from './intro.json'
import introduction from './introduction.json'
import service from './service.json'
import header from './header.json'
import footer from './footer.json'

export default{
    header, intro, introduction, service, footer
}